module.exports = __webpack_public_path__ + "img/boy_selected.8c25df3b.png";